import { useGameStore } from '../../store/gameSlice';
import { useControlsStore } from '../../store/controlsSlice';
import { mouseAimService } from '../../services/MouseAimService';

/**
 * Transparent full-screen layer that captures mouse aim + clicks for the
 * keyboard+mouse preset. Sits above the Pixi canvas but below DOM menus, and is
 * mounted only in the dungeon with mouse control on, so it never swallows menu
 * clicks. No Pixi interactivity is used.
 */
export const MouseAimLayer = () => {
  const gameplay = useGameStore((s) => s.gameplay);
  const activeInterface = useGameStore((s) => s.activeInterface);
  const mouseControl = useControlsStore((s) => s.mouseControlEnabled);

  if (!mouseControl || gameplay !== 'dungeon' || activeInterface) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100,
        cursor: 'crosshair',
      }}
      onPointerMove={(e) => mouseAimService.setCursor(e.clientX, e.clientY)}
      onPointerDown={(e) => {
        if (e.button === 0) {
          mouseAimService.queueLeftClick();
        } else if (e.button === 2) {
          mouseAimService.queueRightClick();
        }
      }}
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};
